import { render, staticRenderFns } from "./SSOAuth.vue?vue&type=template&id=c00fe00c&"
import script from "./SSOAuth.vue?vue&type=script&lang=ts&"
export * from "./SSOAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports